import Vue from "vue";
import Vuex from "vuex";

const Contact = {
  namespaced: true,
  state: {
    contacts: [],
    cities: [],
    pagination: {},
    city: {
      id: null,
      mailMairie: null,
      mailPM: null,
    },
  },
  actions: {
    getContacts(context) {
      return new Promise((resolve, reject) => {
        Vue.axios.get(window.urlapi + "contacts").then((response) => {
          context.commit("GETCONTACTS", response.data.data);
          resolve(response.data.data);
        });
      });
    },
    getCities(context) {
      return new Promise((resolve, reject) => {
        Vue.axios.get(window.urlapi + "cities").then((response) => {
          context.commit("GETCITIES", response.data.data);
          resolve(response.data.data);
        });
      });
    },
    addContact(context, data) {
      console.log(data);
      return new Promise((resolve, reject) => {
        Vue.axios
          .postForm(window.urlapi + "contacts", {
            email: data.email,
            commune: data.commune,
          })
          .then((response) => {
            if (response.data.success == true) {
              context.commit("GETCONTACTS", response.data.data);
              Vue.prototype.$awn.success(response.data.message.toString());
              resolve();
            }
          });
      });
    },
    updateCityNomenclature(context, city) {
      return new Promise((resolve, reject) => {
        Vue.axios
          .put(window.urlapi + "city/" + city.id, city)
          .then((response) => {
            if (response.data.success == true) {
              context.commit("GETCITIES", response.data.data);
              Vue.prototype.$awn.success("email modifié");
              resolve();
            }
          });
      });
    },
    setCity(context, city) {
      context.commit("GETCITY", city);
    },
    getCityById(context, id) {
      return new Promise((resolve, reject) => {
        axios.get(window.urlapi + "city/" + id).then((response) => {
          context.commit("GETCITY", response.data.data);
          resolve(response.data.data);
        });
      });
    },
    getCityByName(context, name) {
      return new Promise((resolve, reject) => {
        Vue.axios.get(window.urlapi + "city/" + name).then((response) => {
          context.commit("GETCITYNAME", response.data.data);
          resolve(response.data.data);
        });
      });
    },
    deleteContact(context, contactId) {
      return new Promise((resolve, reject) => {
        Vue.axios
          .delete(window.urlapi + "contacts/" + contactId)
          .then((response) => {
            if (response.data.success == true) {
              context.commit("GETCONTACTS", response.data.data);
              Vue.prototype.$awn.success(response.data.message.toString());
              resolve();
            }
          });
      });
    },
  },
  mutations: {
    GETCONTACTS: (state, contacts) => {
      state.contacts = contacts;
    },
    GETCITIES: (state, cities) => {
      state.cities = cities;
    },
    GETCITY: (state, city) => {
      state.city = city;
    },
    GETCITYNAME: (state, city) => {
      state.city = city;
    },
    SETPAGINATION: (state, pagination) => {
      state.pagination = pagination;
    },
  },
  getters: {
    contacts: (state) => {
      return state.contacts;
    },
    cities: (state) => {
      return state.cities;
    },
    city: (state) => {
      return state.city;
    },
    pagination: (state) => {
      return state.pagination;
    },
  },
  modules: {},
};

export default Contact;
